import React from 'react';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import IconButton from "@mui/material/IconButton";
import { ReactComponent as HelpIcon } from "./assets/icons/icon-help.svg";
import Tooltip from '@mui/material/Tooltip';
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from '../../../core/utils/GoogleAnalyticTag';
import { GoogleAnalyticTags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags';
import { GoogleAnalytics4Tags } from "../../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: 22,
            height: 22,
            zIndex: 99,
            display: "inline-flex",
            left: 2,
            top: "-11px",
            position: "relative",
            [theme.breakpoints.up('md')]: {

            },
            [theme.breakpoints.down('lg')]: {

            },
            [theme.breakpoints.down('md')]: {

            },
            '& .MuiTooltip-tooltip': {
                boxShadow: "0px 5px 12px 0 rgba(0, 0, 0, 0.08)",
                background: "#ffffff",
                padding: "14px 14px 4px",
                '& .MuiTooltip-arrow': {
                    fontSize: '1.4rem',
                    color: '#ffffff'
                }
            }
        },
        message: {
            fontFamily: "circularStd",
            fontSize: 13,
            lineHeight: 1.6,
            color: "#4a4a4a",
            width: 200,
            height: 'auto',
            minHeight: 68,
            fontWeight: 400,
            margin: 0
        },
        helpButton: {
            top: 17,
            padding: 0,
            marginLeft: 2,
            fontSize: '1em',
            width: 15,
            height: 15,
            '&:hover': {
                backgroundColor: 'transparent'
            }
        },
        show: {
            display: "inline-block"
        },
        hide: {
            display: "none"
        },
    })
);

export default function APToolTip(props: any) {
    const classes = useStyles();
    const [showTooltip, setShowTooltip] = React.useState<boolean>(false);
    const gaTagToolTips = [props.gaTagToolTips];
    const ga4ToolTipTags = props.ga4ToolTipTags;
    const ga4ModuleNameTag = props.ga4ModuleNameTag;
    const title = (
    <p className={classes.message}>{props.toolTipMessage}</p>
    );

    return (
        <div className={classes.root}>
            <Tooltip title={title} arrow placement="top"
                PopperProps={{
                    disablePortal: true
                }}
                open={showTooltip}
                disableFocusListener
                disableHoverListener
                disableTouchListener
            >
                <IconButton
                    data-testid='tooltip'
                    className={classes.helpButton}
                    aria-label="Show Help"
                    onClick={() => {
                        showTooltip === true ? setShowTooltip(false) : setShowTooltip(true);
                        !showTooltip &&
                            TriggerGoogleAnalyticsTag(
                                GoogleAnalyticTags.eventAction.click,
                                gaTagToolTips
                            );
                        !showTooltip &&
                            TriggerGoogleAnalytics4Tag(
                                ga4ModuleNameTag,
                                GoogleAnalytics4Tags.eventAction.click,
                                ga4ToolTipTags
                            )
                    }}
                    size="large">
                    <HelpIcon />
                </IconButton>
            </Tooltip>
        </div>
    );
}
